export default __webpack_public_path__ + "static/media/conversation_hidden.ad86ef4c.svg";